export const SET_INVITES = 'SET_INVITES';
export const ADD_NEW_INVITE = 'ADD_NEW_INVITE';
export const REMOVE_DELETED_INVITES = 'REMOVE_DELETED_INVITES';
export const REMOVE_UNLINKED_USER = 'REMOVE_UNLINKED_USER';
export const ADD_LINKED_USER = 'ADD_LINKED_USER';